<template>
	<li
		class="stamp-list__item stamp-grid__item"
		:style="stempItemStyles"
		@click="clickStamp"
	></li>
</template>

<script>
import stamp from '@/assets/images/asStamp/stamp.png';

export default {
	computed: {
		stempItemStyles() {
			return { backgroundImage: `url(${stamp})` };
		},
	},
	methods: {
		clickStamp() {
			this.$emit('click-stamp');
		},
	},
};
</script>
